import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/i18n/locales";

/** ISO 639-1 код для AI-генерации / STT — из текущей UI-локали. */
export function resolveGenerationLocale(): string {
	return (i18n.language ?? FALLBACK_LOCALE).slice(0, 2);
}
